const sameActor = (
  value: string | null | undefined,
  aiUserId?: string | null,
): boolean => !!aiUserId && value === aiUserId

export const AI_ASSISTED_CALL_HINT = 'Assisted by AI receptionist'

export const AI_APPOINTMENT_FILTER_OPTIONS = ['Booked by AI', 'Updated by AI']
export const AI_PATIENT_FILTER_OPTIONS = ['Created by AI']

/** Selections within the AI category are ORed; no selection includes all records. */
export const matchesAiReceptionistRecordFilter = (
  record: { created_by?: string | null; updated_by?: string | null },
  aiUserId: string | null | undefined,
  selections: string[] = [],
  kind: 'appointment' | 'patient' = 'appointment',
): boolean =>
  selections.length === 0 ||
  (selections.includes(kind === 'patient' ? 'Created by AI' : 'Booked by AI') &&
    sameActor(record.created_by, aiUserId)) ||
  (kind === 'appointment' &&
    selections.includes('Updated by AI') &&
    sameActor(record.updated_by, aiUserId))

/** Appointment created or updated by the AI receptionist user. */
export const isAiReceptionistAppointment = (
  record: {
    created_by?: string | null
    updated_by?: string | null
  },
  aiUserId?: string | null,
): boolean =>
  sameActor(record.created_by, aiUserId) ||
  sameActor(record.updated_by, aiUserId)

/** Call handled by the AI receptionist user. */
export const isAiAssistedCall = (
  call: { handled_by_user_id?: string | null },
  aiUserId?: string | null,
): boolean => sameActor(call.handled_by_user_id, aiUserId)

/** Hover text for an appointment or patient icon. Null when the AI user did not act. */
export const aiReceptionistActorHint = (
  record: {
    created_by?: string | null
    updated_by?: string | null
  },
  aiUserId: string | null | undefined,
  kind: 'appointment' | 'patient',
): string | null => {
  const created = sameActor(record.created_by, aiUserId)
  if (kind === 'patient') {
    return created ? 'Created by AI receptionist' : null
  }
  const updated = sameActor(record.updated_by, aiUserId)
  if (!created && !updated) return null
  return created ? 'Booked by AI receptionist' : 'Updated by AI receptionist'
}
